import React, { memo } from 'react'
import Skeleton from 'transfix-ui/core/Skeleton'

export interface IShipmentStopDetailsSkeletonProps {}

const ShipmentStopDetailsSkeleton = memo<IShipmentStopDetailsSkeletonProps>(() => {
  return (
    <div className='stop'>
      <Skeleton variant='circular' width={8} height={8} />
      <div>
        <Skeleton variant='text' width={80} height={19} />
        <Skeleton variant='text' width={125} height={16} />
      </div>
    </div>
  )
})

export default ShipmentStopDetailsSkeleton
